module.exports = __webpack_public_path__ + "static/media/S (52).7fb5c89e.jpg";